import React, { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { navLinks } from "../mock";
import BrandLockup from "./BrandLockup";
import { ContactLink } from "./ContactLink";

export default function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const goToSection = (event, href) => {
    const target = document.getElementById(href.slice(1));
    setOpen(false);
    if (!target) return;
    event.preventDefault();
    // Measure the destination after React removes the expanded mobile menu.
    requestAnimationFrame(() => {
      if (window.location.hash !== href) {
        window.history.pushState(window.history.state, "", href);
      }
      target.scrollIntoView({ behavior: "smooth", block: "start" });
    });
  };

  return (
    <header className="sticky top-0 z-50">
      {/* Nav */}
      <div className={`border-b transition-all duration-300 ${scrolled ? "backdrop-blur-xl" : ""}`}
           style={{
             background: scrolled ? "rgba(255,253,247,0.9)" : "rgba(255,253,247,0.98)",
             borderColor: "rgba(234,219,197,0.9)"
           }}>
        <div className="container flex items-center justify-between gap-5" style={{ minHeight: 96 }}>
          <a href="#home" data-testid="header-home" aria-label="Kapatia Pvt Ltd home" className="py-2">
            <BrandLockup />
          </a>

          <nav className="hidden lg:flex items-center gap-6 font-heading text-[14px] font-semibold"
               style={{ color: "var(--green-950)" }}>
            {navLinks.map((l) => (
              <a key={l.href} href={l.href} data-testid={`header-nav-${l.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                 className="relative py-1 transition-colors hover:text-[color:var(--orange-700)] after:absolute after:left-0 after:-bottom-0.5 after:h-0.5 after:w-0 after:bg-[color:var(--yellow-500)] after:transition-all hover:after:w-full">
                {l.label}
              </a>
            ))}
            <ContactLink testId="header-call" variant="button" text="Call Now" inverse
              className="kp-button kp-button--compact rounded-full transition-transform hover:-translate-y-0.5"
              style={{ background: "linear-gradient(135deg, var(--green-800), var(--green-950))" }} />
          </nav>

          <button data-testid="header-menu-toggle" className="lg:hidden grid place-items-center h-11 w-11 rounded-xl border bg-white"
                  style={{ borderColor: "var(--line)", color: "var(--green-950)" }}
                  aria-label="Toggle menu" aria-expanded={open}
                  onClick={() => setOpen((v) => !v)}>
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>

        {/* Mobile menu */}
        {open && (
          <div data-testid="header-mobile-menu" className="lg:hidden container pb-4">
            <div className="grid rounded-xl border bg-white overflow-hidden"
                 style={{ borderColor: "var(--line)", boxShadow: "var(--shadow)" }}>
              {navLinks.map((l) => (
                <a key={l.href} href={l.href} onClick={(event) => goToSection(event, l.href)} data-testid={`header-mobile-nav-${l.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                   className="px-4 py-3.5 font-heading text-[15px] font-semibold border-b"
                   style={{ color: "var(--green-950)", borderColor: "var(--line)" }}>
                  {l.label}
                </a>
              ))}
              <ContactLink testId="header-mobile-call" variant="menu" inverse onClick={() => setOpen(false)}
                className="px-4 py-3.5"
                style={{ background: "linear-gradient(135deg, var(--green-800), var(--green-950))" }} />
            </div>
          </div>
        )}
      </div>
    </header>
  );
}
